import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { BankAccountDTO, BankAccountFilters } from '../../models/bank-account.model';

@Injectable({
  providedIn: "root"
})
export class LaravelBankAccountService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/bank_accounts",
      show: environment.baseUrl + "/api/bank_account",
      store: environment.baseUrl + "/api/bank_account",
      destroy: environment.baseUrl + "/api/bank_account",
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: BankAccountFilters,
    includes?: string[]
  ): Observable<ListResultDTO<BankAccountDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<BankAccountDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<BankAccountDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public show(id: number): Observable<BankAccountDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<BankAccountDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(bank_account: BankAccountDTO): Observable<BankAccountDTO> {
    if (bank_account.id) {
      return this.httpClient.put<BankAccountDTO>(`${this.ROUTES.store}`, { bank_account });
    } else {
      return this.httpClient.post<BankAccountDTO>(`${this.ROUTES.store}`, { bank_account });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
